import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";

import Page from "@/components/Page";
import Loading from "@/components/Loading";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import CardsList from "@/components/CardsList";

import {PlayerAPI} from "@/api/player";

import AddIcon from "@mui/icons-material/Add";

import {ERROR_OPERATION, playerRoles} from "@/utils/constants";
import {getBirthYears} from "@/utils/functions";

import "./index.scss";
import {useTranslation} from "react-i18next";

const ITEMS_PER_PAGE = 24;

function ManagerPlayersPage(props) {
	const {handleNotification} = props;

	const navigate = useNavigate();
	const seasonId = useSelector((state) => state?.season?.id);
	const {t} = useTranslation();

	const [loading, setLoading] = useState(false);
	const [filtersData, setFiltersData] = useState(
		JSON.parse(sessionStorage.getItem("manager_player_filters")) || {},
	);

	const [players, setPlayers] = useState([]);
	const [totalItems, setTotalItems] = useState();
	const [currentPage, setCurrentPage] = useState(1);
	const [currentSorting, setCurrentSorting] = useState();
	const [currentSortingOrder, setCurrentSortingOrder] = useState();

	const filters = [
		{
			key: "search",
			label: "Giocatore",
			value: filtersData?.search,
			setValue: (value) => {
				sessionStorage.setItem(
					"manager_player_filters",
					JSON.stringify({search: value}),
				);
				setFiltersData({...filtersData, search: value});
			},
		},
		{
			key: "birthYear",
			label: "Anno di nascita",
			type: "select",
			options: getBirthYears(),
			sorted: false,
			value: filtersData?.birthYear,
			setValue: (value) => {
				sessionStorage.setItem(
					"manager_player_filters",
					JSON.stringify({birthYear: value}),
				);
				setFiltersData({...filtersData, birthYear: value});
			},
		},
		{
			key: "role",
			label: "Ruolo",
			type: "select",
			options: playerRoles,
			sorted: false,
			value: filtersData?.role,
			setValue: (value) => {
				sessionStorage.setItem(
					"manager_player_filters",
					JSON.stringify({role: value}),
				);
				setFiltersData({...filtersData, role: value});
			},
		},
	];

	const getPlayers = async () => {
		setLoading(true);
		try {
			const response = await PlayerAPI.paginated({
				page: currentPage,
				pageSize: ITEMS_PER_PAGE,
				prospect: false,
				sorting: currentSorting,
				descending: currentSortingOrder === "descend",
				...filtersData,
				birthYear: filtersData?.birthYear
					? filtersData.birthYear.value
					: undefined,
				role: filtersData?.role ? filtersData.role.value : undefined,
				seasonId,
			});
			setPlayers(response.data);
			setTotalItems(response.totalRecords);
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		const delayDebounceFn = setTimeout(() => {
			getPlayers();
		}, 500);

		return () => clearTimeout(delayDebounceFn);
	}, [filtersData, currentPage, currentSorting, currentSortingOrder]);

	const handlePageChanged = (currentPage) => {
		setCurrentPage(currentPage);
	};

	const fromOptionToSorting = (sorting) => {
		switch (sorting) {
			case "firstName":
				return 2;
			case "lastName":
				return 1;
			case "dateOfBirth":
				return 3;
			default:
				return;
		}
	};

	const playersListConfiguration = {
		data: players,
		onClick: (player) => navigate("/players/" + player.id),
	};

	const mainActions = [
		{
			icon: <AddIcon />,
			title: "Aggiungi giocatore",
			onClick: () => navigate("/players/new"),
		},
	];

	return (
		<Page>
			<Loading visible={loading} />
			<Breadcrumbs actions={<MainActions actions={mainActions} />} />
			<div className="players-list-container">
				<CardsList
					breadcrumbs
					filtersData={filters}
					type="roster_player"
					listConfiguration={playersListConfiguration}
					sortOptions={[
						{key: "firstName", label: t("name")},
						{
							key: "lastName",
							label: "Cognome",
							sortedByDefault: true,
							sortedOrderByDefault: "ascend",
						},
						{key: "dateOfBirth", label: "Data di nascita"},
					]}
					handleSortChange={(option, order) => {
						setCurrentSorting(fromOptionToSorting(option));
						setCurrentSortingOrder(order);
					}}
					totalItems={totalItems}
					itemsPerPage={ITEMS_PER_PAGE}
					handlePageChanged={handlePageChanged}
				/>
			</div>
		</Page>
	);
}

export default ManagerPlayersPage;
